import { render, staticRenderFns } from "./dyzzd.vue?vue&type=template&id=5ef27324&scoped=true&"
import script from "./dyzzd.vue?vue&type=script&lang=js&"
export * from "./dyzzd.vue?vue&type=script&lang=js&"
import style0 from "./dyzzd.vue?vue&type=style&index=0&id=5ef27324&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef27324",
  null
  
)

export default component.exports